import gql from 'graphql-tag'
import { resourceFragment, resourceTypeFragment } from '@/graphql/resource/resourceFragments'
import { resourceUnavailabilityFragment, resourceUnavailabilityTypeFragment } from '@/graphql/resourceUnavailability/resourceUnavailabilityFragments'

export const RESOURCETYPES = gql`
    query resourceTypes(
        $trashed: Trashed
    ){
        resourceTypes(
            trashed: $trashed
        ){
            ...resourceTypeFragment
        }
    }
    ${resourceTypeFragment}
`
export const RESOURCETYPESRESOURCES = gql`
    query resourceTypes(
        $model: ApplyToModels!
    ){
        resourceTypes{
            ...resourceTypeFragment
            resources(
                model: $model
            ){
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
`

export const RESOURCES = gql`
    query resources(
        $ids: [ID]
        $page: Int
        $first: Int
        $type: [ID]
        $trashed: Trashed
        $orderBy: String = "name"
        $orderSort: SortOrder = ASC
    ){
        resources(
            ids: $ids
            page: $page
            first: $first
            type: $type
            trashed: $trashed
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        ){
            data{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
                unavailabilities{
                    ...resourceUnavailabilityFragment
                    type{
                        ...resourceUnavailabilityTypeFragment
                    }
                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
    ${resourceUnavailabilityFragment}
    ${resourceUnavailabilityTypeFragment}
`

export const RESOURCESSEARCH = gql`
    query resourcesSearch(
        $searchText: String
        $page: Int
        $first: Int
        $type: [ID]
        $trashed: Trashed
    ){
        resourcesSearch(
            searchText: $searchText
            page: $page
            first: $first
            type: $type
            trashed: $trashed
        ){
            data{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
                unavailabilities{
                    ...resourceUnavailabilityFragment
                    type{
                        ...resourceUnavailabilityTypeFragment
                    }
                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
    ${resourceUnavailabilityFragment}
    ${resourceUnavailabilityTypeFragment}
`

export const RESOURCESTRACKINGSEARCH = gql`
    query resourcesTrackingSearch(
        $search: String
        $excludedResources: [ID]
        $excludedUsers: [ID]
        $dates: [dateRangeInput]
        $daysOfWeek: [Int]
        $availability: String
        $resourceTypes: [ID]
    ){
        resourcesTrackingSearch(
            search: $search
            excludedResources: $excludedResources
            excludedUsers: $excludedUsers
            dates: $dates
            daysOfWeek: $daysOfWeek
            availability: $availability
            resourceTypes: $resourceTypes
        ){
            ...resourceFragment
            relevancy
            type{
                ...resourceTypeFragment
            }
            unavailabilities{
                ...resourceUnavailabilityFragment
                type{
                    ...resourceUnavailabilityTypeFragment
                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
    ${resourceUnavailabilityFragment}
    ${resourceUnavailabilityTypeFragment}
`


export const PAGINATEDRESOURCES = gql`
    query paginatedResources(
        $ids: [ID]
        $projects: [ID]
        $type: [ID]
        $page: Int
        $first: Int
        $shiftsDateRange: activeDuringInputSingleDate!
        $orderBy: String = "name"
        $orderSort: SortOrder = ASC
    ){
        paginatedResources(
            ids: $ids
            page: $page
            first: $first
            type: $type
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
                total
            }
            data{
                ...resourceFragment
                type{
                    ...resourceTypeFragment
                }
                unavailabilities(
                    dateRange: $shiftsDateRange
                ){
                    ...resourceUnavailabilityFragment
                    type{
                        ...resourceUnavailabilityTypeFragment
                    }
                }
                assignments(
                    dateRange: $shiftsDateRange
                    projects: $projects
                ){
                    id
                    # name
                    date
                    start_time
                    end_time
                    project_shift_id
                    project_id
                    draft_resource_assignment_id
                    hasAssignmentError
                    draftResourceAssignment{
                        id
                    }
                    project{
                        id
                        name
                    }
                    projectShift{
                        id
                        name
                    }
                }
                draftAssignments(
                    dateRange: $shiftsDateRange
                    projects: $projects
                ){
                    id
                    # name
                    date
                    start_time
                    end_time
                    project_shift_id
                    project_id
                    hasAssignmentError
                    project{
                        id
                        name
                    }
                    projectShift{
                        id
                        name
                    }

                }
            }
        }
    }
    ${resourceFragment}
    ${resourceTypeFragment}
    ${resourceUnavailabilityFragment}
    ${resourceUnavailabilityTypeFragment}
`

export const RESOURCESASSIGNMENTS = gql`
    query resourceAssignments (
        $ids: [ID]
        $projectID: ID
        $resourceID: ID!
        $shiftID: ID
        $dateRange: activeDuringInputSingleDate
        $date: Date
        $dayOfWeek: Int
        $first: Int = 25
        $page: Int = 1
        $includePast: Boolean
    ){
        resourceAssignments(
            ids: $ids
            projectID: $projectID
            resourceID: $resourceID
            shiftID: $shiftID
            dateRange: $dateRange
            date: $date
            dayOfWeek: $dayOfWeek
            first: $first
            page: $page
            include_past: $includePast
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
                total
            }
            data{
                id
                date
                start_time
                end_time
                dayOfWeek
                shift {
                    id
                    name
                }
                project {
                    id
                    name
                }
                projectShift {
                    id
                    name
                    description

                }
            }
        }
    }
`